export default __webpack_public_path__ + "static/media/dummy_balloon.a17403f8.png";